import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { Dayjs } from 'dayjs'
import { FC } from 'react'

type Props = DatePickerProps & {
  id?: string
  label: string | React.ReactNode
  onChange: (data: any) => void
  value?: Dayjs | null
  error: boolean
  helperText: React.ReactNode
  required?: boolean
  validate?: () => void
}

export const CustomDatePicker: FC<Props> = props => {
  const { id, error, helperText, required, validate } = props
  return (
    <DatePicker
      {...props}
      sx={{ width: '100%' }}
      slotProps={{
        textField: {
          id: id,
          variant: 'outlined',
          helperText: error ? helperText : '',
          error: error,
          sx: { width: '100%' },
          required: required,
          onBlur: () => validate?.(),
        },
      }}
    />
  )
}
